import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  SupplierListReq,
  SupplierListRes,
  CreateSupplierReq,
  ActionSupplierRes,
  UpdateSupplierReq,
  DeleteSupplierReq,
  SupplierDetailReq,
  SupplierData,
} from './types'

export const getSupplierListAction = createAsyncAction(
  'SUPPLIER/GET_SUPPLIER_LIST_REQ',
  'SUPPLIER/GET_SUPPLIER_LIST_SUCCESS',
  'SUPPLIER/GET_SUPPLIER_LIST_FAILURE',
)<SupplierListReq, SupplierListRes, Error>()

export const getSupplierDetailAction = createAsyncAction(
  'SUPPLIER/GET_SUPPLIER_DETAIL_REQ',
  'SUPPLIER/GET_SUPPLIER_DETAIL_SUCCESS',
  'SUPPLIER/GET_SUPPLIER_DETAIL_FAILURE',
)<SupplierDetailReq, SupplierData, Error>()

export const createSupplierAction = createAsyncAction(
  'SUPPLIER/CREATE_SUPPLIER_REQ',
  'SUPPLIER/CREATE_SUPPLIER_SUCCESS',
  'SUPPLIER/CREATE_SUPPLIER_FAILURE',
)<CreateSupplierReq, ActionSupplierRes, Error>()

export const updateSupplierAction = createAsyncAction(
  'SUPPLIER/UPDATE_SUPPLIER_REQ',
  'SUPPLIER/UPDATE_SUPPLIER_SUCCESS',
  'SUPPLIER/UPDATE_SUPPLIER_FAILURE',
)<UpdateSupplierReq, ActionSupplierRes, Error>()

export const deleteSupplierAction = createAsyncAction(
  'SUPPLIER/DELETE_SUPPLIER_REQ',
  'SUPPLIER/DELETE_SUPPLIER_SUCCESS',
  'SUPPLIER/DELETE_SUPPLIER_FAILURE',
)<DeleteSupplierReq, ActionSupplierRes, Error>()

export const getAllSupplierListAction = createAsyncAction(
  'SUPPLIER/GET_ALL_SUPPLIER_LIST_REQ',
  'SUPPLIER/GET_ALL_SUPPLIER_LIST_SUCCESS',
  'SUPPLIER/GET_ALL_SUPPLIER_LIST_FAILURE',
)<SupplierListReq, SupplierListRes, Error>()

export const clearEventAction = createStandardAction('SUPPLIER/CLEAR_EVENT')<void>()
